import React, { useState, useEffect } from 'react'
import PackageIcon from './Assets/coursePackageSectionImage.png'
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import Packageslist from './Packageslist'
import { GetEnrollCourseInfo } from '../../../Actions/CourseA';

const Packages = ({ setEnrollmentData, EnrollmentData, PackageRef, Err, setErr, resync, setInstituteCourseId, setInstituteCourseName,
     setInstituteBannerImage, title, CourseInfo }) => {
    const [PackagesArr, setPackagesArr] = useState();
    const { EnrollCourseInfo } = useSelector((Store) => Store.CourseReducer)

    console.log("EnrollCourseInfo in Packages is:", EnrollCourseInfo)
    console.log("CourseInfo in Packages is:", CourseInfo)

    const dispatch = useDispatch();

    useEffect(() => {
        if (title === "CourseOverview" && CourseInfo?.CoursePackages) { // Check if EnrollCourseInfo is defined
            setPackagesArr(CourseInfo.CoursePackages);
            setInstituteCourseId(CourseInfo.InstituteCourseId);
            setInstituteCourseName(CourseInfo.Course.CourseName);
            setInstituteBannerImage(CourseInfo.Institute.Institute_Banner);
            // dispatch(GetEnrollCourseInfo(CourseInfo.InstituteCourseId))
        }      
    }, [title, CourseInfo])

    useEffect(() => {
        if (EnrollCourseInfo) { // Check if EnrollCourseInfo is defined
            setPackagesArr(EnrollCourseInfo.CoursePackages);
            setInstituteCourseId(EnrollCourseInfo.InstituteCourseId);
            setInstituteCourseName(EnrollCourseInfo.Course.CourseName);
            setInstituteBannerImage(EnrollCourseInfo.Institute.Institute_Banner);
        }
        // setPackagesArr(EnrollCourseInfo?.CoursePackages)
        // setInstituteCourseId(EnrollCourseInfo?.InstituteCourseId);
    }, [EnrollCourseInfo, resync])

    return (
        <div className='flex flex-col items-center'
            ref={PackageRef}
            id='Package'>
            <div className='flex flex-col items-center gap-5 w-full bg-[#F6F5F5] pt-5 pb-3 h-fit'>
                <img className='w-20 md:w-28 lg:w-32' src={PackageIcon} alt="" />
                <h1 className={`text-center px-2 SemiBoldItalic text-black h-fit m-0
                                text-xs sm:text-base    md:text-lg              xl:text-[38px]`}>
                    {/* Select a Package That suits you best */}
                    Find the Perfect Course Package for Your Needs
                </h1>
                {/* <h3 className={`text-center font-normal
                                text-3xs                md:text-2xs lg:text-xs  xl:text-base`}>
                    Our prices are given below:
                </h3> */}
                <h4 className='font-normal text-[red]'>{Err?.Package ? Err?.Package : null}</h4>
            </div>

            <Packageslist PackagesArr={PackagesArr} setEnrollmentData={setEnrollmentData} EnrollmentData={EnrollmentData}
                setErr={setErr} Err={Err}
                title={title}
                CourseInfo={CourseInfo}
            />
        </div>
    )
}

export default Packages